import styled from 'styled-components';

export const ToggleVisBtn = styled.div`
  display: flex;
  font-weight: 500;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.6rem 1rem;
`;

export const VisIcon = styled.div`
  position: relative;
  top: 1px;
  color: ${(props) =>
    props.active ? 'var(--primary-color)' : 'var(--neutral-color)'};
`;

export const Text = styled.div``;
